import { AnchorButton } from "src/components/ui-components/Button/AnchorButton";
import { AlertsIllustration } from "./AlertsIllustration";
import styles from "./AuthPages.module.css";
import { IconArrowUpRight } from "src/components/ui-components/Icons/IconArrowUpRight";

export function AlertsUpsell() {
  return (
    <div className={styles.alertsUpsell}>
      <div>
        <AlertsIllustration />
      </div>
      <h3>Alerts</h3>
      <h2>
        Receive the output of scheduled queries via email or webhooks, including
        Slack.
      </h2>
      <AnchorButton
        theme="secondary"
        size="L"
        href="/docs/app/alerts"
        target="_blank"
      >
        Learn more in the docs <IconArrowUpRight />
      </AnchorButton>
    </div>
  );
}
